module.exports = __webpack_public_path__ + "static/google-play-03ee440cd6018ca89297d7dcfb58a510.png";